<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

    <!-- <el-container>
      <el-header>Header</el-header>
      <el-container>
        <el-aside>Aside</el-aside>
        <el-container>
          <el-main>Main</el-main>
          <el-footer>Footer</el-footer>
        </el-container>
      </el-container>
    </el-container> -->
    <router-view></router-view>
  </div>
</template>

<script>
  export default{
    watch:{
      '$route'(to, from) {
        document.documentElement.scrollTop = 0;
			},
    }
  }
</script>

<style>
  body{margin:0;}
</style>
